import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Tooltip, IconButton } from '@material-ui/core';
import { LinkOff as LinkOffIcon, RemoveRedEye as ViewIcon, People as PeopleIcon } from '@material-ui/icons';
import { FHETable, DetailPanelUsers } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { dissociateSDM17SPGUser, dissociateSDM17SPGUserAndSwitchMaster } from '../../../data/SDM17SPG/actions';

class TableSDM17SPG extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dissociateSDM17SPGUser: PropTypes.func.isRequired,
        dissociateSDM17SPGUserAndSwitchMaster: PropTypes.func.isRequired,
        SDM17SPGs: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        userId: PropTypes.number.isRequired,
        profile: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            dissociateLoading: null
        };
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/SDM17SPG/detail/${rowData.id}` });
    };

    navigateToUser = event => {
        const { history } = this.props;
        return history.push({
            pathname: `/${history.environment}/user/detail/${event.currentTarget.getAttribute('data-userid')}`
        });
    };

    /* ACTIONS */
    dissociateUser = SDM17SPGMac => {
        const { dissociateSDM17SPGUser, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM17SPGMac });

        dissociateSDM17SPGUser(SDM17SPGMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM17SPG.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM17SPG.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMaster = SDM17SPGMac => {
        const { dissociateSDM17SPGUser, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM17SPGMac });

        dissociateSDM17SPGUser(SDM17SPGMac, userId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM17SPG.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM17SPG.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateMasterAndSwitch = (SDM17SPGMac, newMasterId) => {
        const { dissociateSDM17SPGUserAndSwitchMaster, userId, history } = this.props;
        this.setState({ dissociateLoading: SDM17SPGMac });

        dissociateSDM17SPGUserAndSwitchMaster(SDM17SPGMac, userId, newMasterId)
            .then(() => {
                Toastr.success(Translator.translate(`general.products.SDM17SPG.table.action.dissociate.success`));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate(`general.products.SDM17SPG.table.action.dissociate.error`)
                );
            })
            .finally(() => {
                this.setState({ dissociateLoading: null });
            });
    };
    dissociateProduct = rowData => {
        const { dissociateLoading } = this.state;
        const { userId, history } = this.props;
        if (dissociateLoading === rowData.id) return false;
        if (rowData.otherUsers.length === 0 && rowData.userMasterId === userId) {
            Toastr.confirm(
                Translator.translate(`general.products.SDM17SPG.table.action.dissociate.confirmRemoveMasterAlone`, rowData.macAddress),
                Translator.translate(`general.products.SDM17SPG.table.action.dissociate.confirmRemoveMasterTitle`),
                {
                    onYes: () => {
                        this.dissociateMaster(rowData.id);
                    }
                }
            );
        } else if (rowData.userMasterId === userId) {
            Toastr.select(
                Translator.translate(`general.products.SDM17SPG.table.action.dissociate.confirmRemoveMaster`, rowData.macAddress),
                Translator.translate(`general.products.SDM17SPG.table.action.dissociate.confirmRemoveMasterTitle`),
                rowData.otherUsers,
                {
                    onYes: newMasterId => {
                        this.dissociateMasterAndSwitch(rowData.id, parseInt(newMasterId));
                    }
                }
            );
        } else {
            Toastr.confirm(
                Translator.translate(`general.products.SDM17SPG.table.action.dissociate.confirmRemove`, rowData.macAddress),
                Translator.translate(`general.products.SDM17SPG.table.action.dissociate.confirmRemoveTitle`),
                {
                    onYes: () => {
                        this.dissociateUser(rowData.id);
                    }
                }
            );
        }
    };

    /* RENDER */
    renderData = memoizeOne(SDM17SPGs => {
        let result = [];

        SDM17SPGs.map(SDM17SPG => {
            result.push({
                id: SDM17SPG.get('macAddress'),
                macAddress: SDM17SPG.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                addressIp: SDM17SPG.get('addressIp'),
                email: SDM17SPG.get('userEmail'),
                label: SDM17SPG.get('label'),
                state: SDM17SPG.getIn(['state'], false) ? Translator.translate(`general.${SDM17SPG.get('state')}`) : null,
                firmwareVersion: SDM17SPG.get('firmwareVersion'),
                usersList: SDM17SPG.get('usersList'),
                otherUsers: SDM17SPG.get('otherUsers'),
                userMasterId: SDM17SPG.get('userMasterId')
            });
        });
        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [
                {
                    icon: LinkOffIcon,
                    onClick: this.dissociateProduct,
                    tooltip: Translator.translate(`general.products.SDM17SPG.table.action.dissociate.tooltip`)
                }
            ],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('SDM17SPGDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderDetails = memoizeOne(() => {
        return {
            renderToggleCell: ({ row, onToggle }) => {
                return (
                    <Tooltip title={Translator.translate('general.table.button.showUserList')} disableHoverListener={!row.userMasterId}>
                        <span>
                            <IconButton onClick={onToggle} disabled={!row.userMasterId}>
                                <PeopleIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
            renderPanel: ({ row }) => {
                return <DetailPanelUsers usersList={row.usersList} userMasterId={row.userMasterId} onClick={this.navigateToUser} />;
            }
        };
    });

    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM17SPGDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.addressIp'),
                name: 'addressIp'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });

    renderSDM17SPG() {
        const { SDM17SPGs, profile } = this.props;

        return (
            <FHETable
                idTable="userDetailSDM17SPG"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM17SPGs)}
                actions={this.renderActions(profile)}
                rowDetail={this.renderDetails()}
                minified
            />
        );
    }

    render() {
        const { SDM17SPGs, history } = this.props;
        return (
            <Fragment>
                {SDM17SPGs.size > 0 ? this.renderSDM17SPG() : Translator.translate(`general.products.SDM17SPG.table.body.emptyDataSourceMessage`)}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const userId = props.match.params.userId;
    const users = state.environments[history.environment].data.Users.get('list');
    const actualUser = users.getIn([userId], new Map());
    let SDM17SPGs = state.environments[history.environment].data.SDM17SPG.get('list')
        .filter(SDM17SPG => {
            return SDM17SPG.getIn(['usersList'], []).indexOf(parseInt(userId)) !== -1;
        })
        .map(SDM17SPG => {
            const masterUser = users.getIn([SDM17SPG.getIn(['userMasterId'], '').toString()], new Map());
            let otherUsers = [];
            const usersList = SDM17SPG.getIn(['usersList'], [])
                .map(_userId => {
                    const _user = users.getIn([_userId.toString()], new Map());
                    if (parseInt(userId) !== _user.get('_id'))
                        otherUsers.push({ id: _user.get('_id'), label: `${_user.get('firstname')} ${_user.get('lastname')}` });
                    return _user;
                })
                .sort(a => {
                    if (a.get('_id') === SDM17SPG.get('userMasterId')) return -1;
                    else return 1;
                });
            return SDM17SPG.set('userEmail', masterUser.get('email'))
                .set('usersList', usersList)
                .set('otherUsers', otherUsers);
        });
    return {
        profile: state.data.user,
        user: actualUser,
        users,
        SDM17SPGs
    };
}

const styles = theme => ({
    detailPanelHeader: {
        color: theme.palette.text.secondary
    },
    masterRow: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark
    },
    userRow: {
        backgroundColor: 'white',
        color: theme.palette.text.secondary
    },
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { dissociateSDM17SPGUser, dissociateSDM17SPGUserAndSwitchMaster }), dispatch)
    )(withStyles(styles, { withTheme: true })(TableSDM17SPG))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/Table/TableSDM17SPG.js